import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createSearchIntegration } from '../search/workhub-search-factory.js';
import { createWorkHubManager } from '../workhub/workhub-manager-factory.js';
import { DBDef_AIPrompt } from '@nu-art/prompting-shared';
import { Editor_AIPrompt, ModuleFE_AIPrompt } from '@nu-art/prompting-frontend';
import { Header_AIPrompt } from './Header_AIPrompt.js';
const defaultAIPrompt = Object.freeze({
    label: 'New Prompt',
});
export const Manager_AIPrompt = createWorkHubManager({
    module: ModuleFE_AIPrompt,
    dbDef: DBDef_AIPrompt,
    defaultItem: defaultAIPrompt,
    labelResolver: (prompt) => prompt.label ?? 'New Prompt',
    EditorComponent: (p) => _jsxs(_Fragment, { children: [_jsx(Header_AIPrompt, { editable: p.editable, editMode: p.renderArgs.editMode }), _jsx(Editor_AIPrompt, { editable: p.editable, editMode: p.renderArgs.editMode })] }),
});
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_AIPrompt,
    dbDef: DBDef_AIPrompt,
    tag: ['AIP', 'AI Prompt'],
    modulesToAwait: [ModuleFE_AIPrompt],
    ManagerComponent: Manager_AIPrompt,
    searchTermsExtractor: (item) => {
        return [item.label.toLowerCase(), item._id];
    },
});
export const WorkHubItem_AIPrompt = WorkHubItem;
export const UtilObject_AIPrompt = UtilObject;
export const SearchItem_AIPrompt = SearchItem;
//# sourceMappingURL=integration.js.map